import React from "react";
import classes from "./IconGallery.module.css";

const IconGallery = ({ icons, selectedUrl, onSelect }) => {
    return (
        <div className={classes.Gallery}>
            {icons?.map(({ id, url }) => (
                <button
                    key={id}
                    type="button"
                    className={`${classes.Tile} ${selectedUrl === url ? classes.TileSelected : ""}`}
                    onClick={() => onSelect(selectedUrl === url ? "" : url)}
                >
                    <img src={url} alt="" className={classes.TileImg} />
                    <input
                        type="radio"
                        readOnly
                        checked={selectedUrl === url}
                        tabIndex={-1}
                        className={classes.RadioDot}
                    />
                </button>
            ))}
        </div>
    );
};

export default IconGallery;
